module.exports = __webpack_public_path__ + "static/adelle_semibolditalic-webfont-woff-944ab5c06b33a1f57ebbb59555c0efbd.woff";